import React from "react";
import "./FooterSite.css";
import { useNavigate, NavLink, Navigate, useLocation } from "react-router-dom";
import LoginSite from "./LoginSite";
const FooterSite = () => {
    const navigate = useNavigate();
    
   // if (localStorage.getItem("hashLogin") === null || localStorage.getItem("hashLogin") == undefined 
   // || localStorage.getItem("hashLogin") == "")
   //     return <LoginSite/>
   //     else
    return (

        

        <footer className="footerClass" align="center">
       {/* <div className="row">
            <div className="col">
                <img align="center" className="imagen1" src="./footer-help.png" width="70%" onClick={()=>{navigate("/chat")}}/>
            </div>
    </div>*/}
        <div className="row">
          
       
        <div className="col">
        <img align="center" width="65%" src="./appmimuni_footer_pilar.png"/>
            <img align="right" className="marginFooterRight" width="45px" src="./chat-robot.svg" onClick={()=>{navigate("/chat")}}/>
        </div>
        </div>
   </footer>
    

    );
}

export default FooterSite;